import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import postalcode from "../../../containers/modules/master/postalcode";

export default function PostalCodeRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="postalcode"
      index
      element={
        <AccessControl
          name={"Postal Code List"}
          auth={authUser}
          component={postalcode}
        />
      }
    />
  );
}
